<template>
    <v-flex xs12>
        <v-layout>
            <v-flex xs6>
                <h3 class="display-2">Asignación de empresa</h3>
                <v-autocomplete :items="users" v-model="user" @input="datos()" label="Elija usuario" single-line bottom item-text="name"
                          item-value="id"></v-autocomplete>
                <v-checkbox label="Friolatina" v-model="emp" value="1"></v-checkbox>
                <v-checkbox label="Bervill" v-model="emp" value="2"></v-checkbox>
                <v-checkbox label="Acerolatina" v-model="emp" value="3"></v-checkbox>
            </v-flex>
        </v-layout>
        <v-btn @click.native="guardar" :loading="loading">Guardar</v-btn>
    </v-flex>
</template>
<script>
    import usersMixin from '../../mixins/auth/users'

    export default {
        name: 'permisos',
        mixins: [usersMixin],
        data() {
            return {
                loading: false,
                user: '',
                users: [],
                emp: []
            }
        },
        mounted() {
            this.usersList(r => {
                this.users = r
            }, err => {
                alert(err)
            })
        },
        methods: {
            datos() {
                this.loading = true
                this.$http.post('empresa/asignada', {user: this.user, emp: this.emp})
                    .then(r => {
                        for (let i = 0; i < r.data.empresas.length; i++) {
                            this.emp.push(String(r.data.empresas[i].id))
                        }
                        this.loading = false;
                    }, r => {
                        this.loading = false;
                    });
            },
            guardar() {
                this.loading = true
                this.$http.post('empresa/asignar', {user: this.user, emp: this.emp})
                    .then(r => {
                        this.loading = false;
                    }, r => {
                        this.loading = false;
                    });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/auth/usuario_empresa.vue